// Collection Header Carousel Functionality

class CollectionHeaderCarousel {
  constructor() {
    this.carousels = document.querySelectorAll('[data-carousel]');
    this.init();
  }

  init() {
    this.carousels.forEach((carousel) => {
      this.setupCarousel(carousel);
    });
  }

  setupCarousel(carousel) {
    const items = carousel.querySelectorAll('.collection-header__carousel-item');
    const prevBtn = carousel.parentElement.querySelector(
      '.collection-header__carousel-button--prev'
    );
    const nextBtn = carousel.parentElement.querySelector(
      '.collection-header__carousel-button--next'
    );
    const dotsContainer = carousel.parentElement.querySelector(
      '[data-dots-container]'
    );
    const dots = dotsContainer
      ? Array.from(dotsContainer.querySelectorAll('.collection-header__dot'))
      : [];

    if (items.length === 0) return;

    let currentSlide = 0;

    // Set initial active slide
    this.setActiveSlide(items, dots, currentSlide);

    // Previous button functionality
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentSlide = currentSlide === 0 ? items.length - 1 : currentSlide - 1;
        this.setActiveSlide(items, dots, currentSlide);
      });
    }

    // Next button functionality
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentSlide = currentSlide === items.length - 1 ? 0 : currentSlide + 1;
        this.setActiveSlide(items, dots, currentSlide);
      });
    }

    // Dot click functionality
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        currentSlide = index;
        this.setActiveSlide(items, dots, currentSlide);
      });
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (carousel.querySelector('.collection-header__carousel-item.active')) {
        if (e.key === 'ArrowLeft') {
          currentSlide =
            currentSlide === 0 ? items.length - 1 : currentSlide - 1;
          this.setActiveSlide(items, dots, currentSlide);
        } else if (e.key === 'ArrowRight') {
          currentSlide =
            currentSlide === items.length - 1 ? 0 : currentSlide + 1;
          this.setActiveSlide(items, dots, currentSlide);
        }
      }
    });

    const autoPlayInterval = setInterval(() => {
      currentSlide = currentSlide === items.length - 1 ? 0 : currentSlide + 1;
      this.setActiveSlide(items, dots, currentSlide);
    }, 5000);
    
  }

  setActiveSlide(items, dots, index) {
    items.forEach((item) => {
      item.classList.remove('active');
      const video = item.querySelector('video');
      if (video) video.pause();
    });

    items[index].classList.add('active');

    const activeVideo = items[index].querySelector('video');
    if (activeVideo) activeVideo.play().catch(() => {});

    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }
}

// Initialize carousel when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CollectionHeaderCarousel();
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionHeaderCarousel();
  });
} else {
  new CollectionHeaderCarousel();
}
